
import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UCommaListAndLast extends Vue {
  // Props

  @Prop({ default: () => [] })
  public items!: string[];

  @Prop({ default: "span" })
  public tag!: string;

  // Computed

  public get list() {
    return [...this.items].slice(0, -1);
  }

  public get last() {
    return [...this.items].pop();
  }

  public render(h: CreateElement) {
    return h(this.tag, {}, [
      this.$tc("_plurals.comma_list_and_last", this.items.length, {
        list: this.list.join(", "),
        last: this.last
      })
    ]);
  }
}
